import axiosInstance from "./AxiosConfig";

class FormDetailsApi {
  async CreateFormDetails(data) {
    try {
      const response = await axiosInstance.post("/formDetails/create", data);
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  async GetAllFormDetails() {
    try {
      const response = await axiosInstance.get("/formDetails/get");
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  async UpdateFormDetails(id, data) {
    try {
      const response = await axiosInstance.put(`/formDetails/update/${id}`, data);
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  async DeleteFormDetails(id, data = {}) {
    try {
      const response = await axiosInstance.delete(`/formDetails/delete/${id}`, { data });
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
}

export default new FormDetailsApi();
